import { Typography, Card, Box, IconButton, Tooltip } from "@mui/material";
import DetailsCardButton from "./DetailsCardButton";
import StarIcon from "@mui/icons-material/Star";
import ChannelStatusMenu, { getStatusLabel } from "./ChannelStatusMenu";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import { useSelectedItemStore } from "../store/useSelectedItemStore";
import LinkIcon from "@mui/icons-material/Link";

interface ProcessItemProps {
  process: any;
  onClick: () => void;
  checked: boolean;
  hasAssociatedUsers?: boolean;
}

const ProcessItemCard: React.FC<ProcessItemProps> = ({
  process,
  onClick,
  checked,
  hasAssociatedUsers = false,
}) => {
  const navigate = useNavigate();
  const setSelectedItemId = useSelectedItemStore((s) => s.setSelectedItemId);

  const handleDetailsClick = () => {
    setSelectedItemId(process.CD_PROCESSO);
    navigate(RoutesConfig.DETALHESPROCESSO.path);
  };

  return (
    <Card
      key={process.CD_PROCESSO}
      sx={{
        position: "relative",
        display: "flex",
        width: "100%",
        height: "97px",
        borderRadius: "16px",
        backgroundColor: "#F6F6F6",
        boxShadow: "0px 3px 6px #00000029",
        marginBottom: "26px",
        paddingLeft: "16px",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          width: "21px",
          height: "100%",
          backgroundColor: "#326AFD",
          borderRadius: "12px 0px 0px 12px",
        }}
      />
      <Box
        sx={{
          marginLeft: "14px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Processo
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ID: {process.CD_PROCESSO}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          DI <strong>{process.NR_DI}</strong>
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            fontSize={"10px"}
            textAlign="left"
          >
            {process.NM_LOC_EMBARQUE}
          </Typography>
          <DetailsCardButton onClick={handleDetailsClick} />
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "35px",
          right: "10px",
          transform: "translateY(-50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        {hasAssociatedUsers ? (
          <IconButton
            onClick={onClick}
            sx={{
              width: "24px",
              height: "24px",
              backgroundColor: checked ? "#0A0C33" : "transparent",
              borderRadius: "6px",
              padding: 0,
              transition: "background-color 0.3s ease",
              border: "1px solid #0A0C33",
            }}
          >
            <LinkIcon
              style={{
                color: checked ? "#A5EB17" : "#0A0C33",
                width: "14px",
                height: "14px",
              }}
              sx={{ transform: "rotate(45deg)" }}
            />
          </IconButton>
        ) : (
          <IconButton
            onClick={onClick}
            sx={{
              width: "24px",
              height: "24px",
              border: "1px solid #0A0C33",
              borderRadius: "4px",
              backgroundColor: checked ? "#0A0C33" : "transparent",
              color: checked ? "#A5EB17" : "#0A0C33",
              padding: "2px",
              transition: "all 0.3s ease",
            }}
          >
            <StarIcon sx={{ fontSize: "18px" }} />
          </IconButton>
        )}

        <Tooltip
          title={`Canal ${getStatusLabel(process.CANAL)}`}
          arrow
          style={{ alignItems: "center" }}
          PopperProps={{
            modifiers: [
              { name: "zIndex", enabled: true, options: { zIndex: 9999 } },
            ],
          }}
        >
          <span>
            <ChannelStatusMenu status={process.CANAL} isLabel={false} />
          </span>
        </Tooltip>
      </Box>
    </Card>
  );
};

export default ProcessItemCard;
